import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ApiService } from '../../services/api/api.service';
import { FormatService } from '../../services/format/format.service';

declare const $:any;

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.css']
})
export class RoleListComponent implements OnInit {
  isForm : any;
  isData : any = [];
  isTotalAll : number = 0;
  isKeyword : string = '';

  isPage : number = 1;
  isPageSize : number = 10;
  isPages : any = [];
  isTableLoading : boolean = false;

  isLoading = false;

  // catalog of every menu permission, grouped for the checkbox grid — grouping
  // mirrors the sidebar sections so it reads the same way it looks there
  dataPermissions : any = [];
  private groupOf : any = {
    dashboard: 'Utama', user: 'Utama', complaint: 'Utama',
    audio: 'Konten', contentFeed: 'Konten', contentVideo: 'Konten', hafalan: 'Konten', murojaah: 'Konten', faq: 'Konten',
    voucherList: 'Monetisasi', voucherBackground: 'Monetisasi', subscribeVoucher: 'Monetisasi',
    subscribeStore: 'Monetisasi', subscriptionPlan: 'Monetisasi', sahamqu: 'Monetisasi',
    setoran: 'Lainnya', grupNgaji: 'Lainnya', guru: 'Lainnya', guruPostingan: 'Lainnya', monitoring: 'Lainnya', tilawah: 'Lainnya',
    konfigurasi: 'Sistem',
  };
  permissionGroups : any = [];
  selectedIds : Set<number> = new Set();

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private formatService: FormatService,
  ) { }

  ngOnInit(): void {
    this.isPageSize = this.apiService.LIMIT || 10;
    this.resetForm();
    this.getPermissions();
    this.getData();
  }

  async resetForm(){
    this.isForm = this.fb.group({
      id : new FormControl(''),
      name : new FormControl('', [Validators.required]),
    });
    this.selectedIds = new Set();
  }

  getPermissions(){
    this.apiService.methodGetSilent(`role/permissions`, this.authService.getToken()).subscribe((response) => {
      if(response && response.status == 200){
        this.dataPermissions = response.data;
        const byGroup: any = {};
        this.dataPermissions.forEach((p: any) => {
          const g = this.groupOf[p.key] || 'Lainnya';
          (byGroup[g] = byGroup[g] || []).push(p);
        });
        this.permissionGroups = Object.keys(byGroup).map(name => ({name, items: byGroup[name]}));
      }
    });
  }

  private searchTimer : any;
  private lastQuery : string = '';

  onKeywordInput(value : string){
    this.isKeyword = value;
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.applyFilter(), 450);
  }

  async applyFilter(){
    clearTimeout(this.searchTimer);
    if(this.isKeyword === this.lastQuery){ return; }
    this.lastQuery = this.isKeyword;
    this.isPage = 1;
    await this.getData();
  }

  async onReset() {
    this.isPage = 1;
    this.isKeyword = '';
    this.lastQuery = '';
    await this.resetForm();
    await this.getData();
  }

  async getData(){
    let searchData = {"keyword":this.isKeyword};
    const offset = (this.isPage - 1) * this.isPageSize;
    this.isTableLoading = true;
    try{
      this.apiService.methodGetSilent(`role/${offset}/${encodeURIComponent(JSON.stringify(searchData))}`,this.authService.getToken()).subscribe((response)=>{
        this.isTableLoading = false;
        if(response && response.status == 200) {
          this.isData = response.data || [];
          this.isTotalAll = response.total || 0;
          this.buildPager();
        }
      }, () => { this.isTableLoading = false; })
    }catch(error){
      this.isTableLoading = false;
      console.log(error);
    }
  }

  permissionCount(role : any){
    return (role.permissions || []).length;
  }

  totalPages(){
    return Math.max(1, Math.ceil(this.isTotalAll / this.isPageSize));
  }
  buildPager(){
    const total = this.totalPages();
    const pages: any[] = [];
    for(let p = 1; p <= total; p++){
      if(p == 1 || p == total || Math.abs(p - this.isPage) <= 1){
        pages.push(p);
      }else if(pages[pages.length - 1] != '...'){
        pages.push('...');
      }
    }
    this.isPages = pages;
  }
  async goToPage(p: any){
    const total = this.totalPages();
    if(p < 1 || p > total || p == this.isPage){ return; }
    this.isPage = p;
    await this.getData();
  }
  rowNo(i: number){
    return (this.isPage - 1) * this.isPageSize + i + 1;
  }
  summaryFrom(){
    return this.isTotalAll ? (this.isPage - 1) * this.isPageSize + 1 : 0;
  }
  summaryTo(){
    return (this.isPage - 1) * this.isPageSize + this.isData.length;
  }
  formatNumber(value : any){
    return this.formatService.dotFormat(value || 0);
  }

  highlight(text : any){
    const esc = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const keyword = this.isKeyword.trim();
    if(!keyword){ return esc; }
    const escapedKeyword = keyword
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return esc.replace(new RegExp(`(${escapedKeyword})`, 'gi'), '<mark class="vl-hl">$1</mark>');
  }

  isChecked(id : number){
    return this.selectedIds.has(id);
  }
  togglePermission(id : number, event : any){
    if(event.target.checked){ this.selectedIds.add(id); }
    else{ this.selectedIds.delete(id); }
  }
  toggleGroup(group : any, checked : boolean){
    group.items.forEach((p: any) => {
      if(checked){ this.selectedIds.add(p.id); } else { this.selectedIds.delete(p.id); }
    });
  }
  isGroupChecked(group : any){
    return group.items.every((p: any) => this.selectedIds.has(p.id));
  }

  isInvalid(control : string){
    const c = this.isForm.get(control);
    return c && c.invalid && (c.touched || c.dirty);
  }

  async onShowAdd(){
    await this.resetForm();
    $('#formData').modal({backdrop: 'static', keyboard: false})
  }

  async onEdit(v : any){
    try{
      await this.resetForm();
      await this.isForm.patchValue({id: v.id, name: v.name});
      this.selectedIds = new Set((v.permissions || []).map((p: any) => p.id));
      await $('#formData').modal({ backdrop: 'static', keyboard: false, show: true });
    }catch(error){
      console.log(error);
    }
  }

  async onSubmit(){
    try{
      if(this.isForm.invalid){
        this.isForm.markAllAsTouched();
        return;
      }
      if(this.isLoading){ return; }
      this.isLoading = true;
      const payload = {
        ...this.isForm.getRawValue(),
        permission_ids: Array.from(this.selectedIds),
      };
      const isEdit = !!payload.id;
      const request = isEdit
        ? this.apiService.methodPutSilent(`role/${payload.id}`, payload, this.authService.getToken())
        : this.apiService.methodPostSilent(`role`, payload, this.authService.getToken());
      request.subscribe(async(response)=>{
        this.isLoading = false;
        if (response && response.status == 200) {
          $('#formData').modal('hide');
          await this.toastr.success(payload.name, isEdit ? `Role diupdate` : `Role dibuat`);
          await this.onReset();
        } else {
          await this.toastr.error((response && response.message) || `Periksa isian lalu coba lagi.`, `Gagal menyimpan`);
        }
      }, async () => {
        this.isLoading = false;
        await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal menyimpan`);
      });
    }catch(error){
      this.isLoading = false;
      await this.toastr.error(`Periksa isian lalu coba lagi.`, `Gagal menyimpan`);
    }
  }

  // ===== delete confirmation =====
  isConfirm : any = null;
  isDeleting : boolean = false;

  onDelete(v : any){
    this.isConfirm = {v: v};
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      const btn: any = document.querySelector('.hds-dialog .vl-btn-ghost');
      if(btn){ btn.focus(); }
    });
  }

  closeConfirm(){
    if(this.isDeleting){ return; }
    this.isConfirm = null;
    document.body.style.overflow = '';
  }

  @HostListener('document:keydown.escape')
  onEscapeConfirm(){
    if(this.isConfirm){ this.closeConfirm(); }
  }

  async confirmDelete(){
    const c = this.isConfirm;
    if(!c || this.isDeleting){ return; }
    this.isDeleting = true;
    this.apiService.methodDeleteSilent(`role/${c.v.id}`, this.authService.getToken()).subscribe(async (response)=>{
      this.isDeleting = false;
      if(response && response.status == 200) {
        this.closeConfirm();
        await this.toastr.success(c.v.name, `Role dihapus`);
        await this.getData();
        if(this.isData.length === 0 && this.isPage > 1){
          this.isPage = this.isPage - 1;
          await this.getData();
        }
      } else {
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, `Gagal menghapus`);
      }
    }, async () => {
      this.isDeleting = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal menghapus`);
    });
  }
}
